import React from 'react'
import { PALETTE } from '../../common/ThemeConstants'
import WorkoutExerciseForm from './WorkoutExerciseForm'
import { getRequest, deleteRequest } from '../../api/axiosRequests'
import CardAdminWorkoutExercise from './CardAdminWorkoutExercise'
import AlertModal from '../../common/components/AlertModal'

import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { Button } from 'react-bootstrap'
import { useState, useEffect } from 'react'

import { FaEdit } from 'react-icons/fa'
import { IoClose } from 'react-icons/io5'


export default function CardAdminSuperserie({ superserie, height = 100, editCallback, onDeleteButtonClicked }) {
  const [currentWorkoutExercise, setCurrentWorkoutExercise] = useState({ id: -1 })
  const [workoutExercises, setWorkoutExercises] = useState([])
  const [showEditForm, setShowEditForm] = useState(false)
  const [showDeleteForm, setShowDeleteForm] = useState(false)

  async function fetchWorkoutExercises() {
    try {
      const headers = { 'Authorization': localStorage.getItem('jwt') }
      const response = await getRequest('workoutExerciseList/', headers)
      const data = response.data
      const parsedData = data.filter(we => we.superserie === superserie.id).sort((a, b) => (a.position > b.position ? 1 : -1))
      console.log(parsedData)
      setWorkoutExercises(parsedData)
    } catch (err) { }
  }

  function getNextWorkoutExercisePosition() {
    if (workoutExercises.length == 0) {
      return 0;
    }
    return workoutExercises.at(-1).position + 1;
  }

  const onEditFormSubmit = () => {
    fetchWorkoutExercises()
    setShowEditForm(false)
  }

  const onEditButtonClicked = (id) => {
    const currentWorkoutExercise = workoutExercises.filter(w => w.id === id)[0]
    setCurrentWorkoutExercise(currentWorkoutExercise)
    setShowEditForm(true)
  }

  const onDeleteExerciseButtonClicked = (id) => {
    const currentWorkoutExercise = workoutExercises.filter(w => w.id === id)[0]
    setCurrentWorkoutExercise(currentWorkoutExercise)
    setShowDeleteForm(true)
  }

  async function deleteCallback(id) {
    const headers = { 'Authorization': localStorage.getItem('jwt') }
    const response = await deleteRequest('workoutExercise/' + id, headers)
    setShowDeleteForm(false)
    fetchWorkoutExercises()
  }

  const resetCurrentWorkoutExercise = () => {
    setCurrentWorkoutExercise({ id: -1 })
  }

  const onAddWorkoutExerciseButtonClicked = () => {
    resetCurrentWorkoutExercise()
    setShowEditForm(true)
  }

  useEffect(() => {
    fetchWorkoutExercises()
  }, [])

  return (
    <>
      <AlertModal
        show={showDeleteForm}
        getDataId={() => { return currentWorkoutExercise.id }}
        onHide={() => { setShowDeleteForm(false) }}
        onCancel={() => { setShowDeleteForm(false) }}
        onConfirm={(id) => { deleteCallback(id) }}
        title={"Delete workout"}
        description={"Are you sure you want to delete the workout?"}
      />
      <WorkoutExerciseForm
        idSuperserie={superserie.id}
        getCurrentWorkoutExercise={() => { return currentWorkoutExercise }}
        getPos={() => {
          return getNextWorkoutExercisePosition();
        }}
        onHide={() => { setShowEditForm(false) }}
        show={showEditForm}
        onSubmit={onEditFormSubmit}
      />
      <Card className="m-2 p-2" style={{ border: "solid 0px", backgroundColor: PALETTE.LIGHTGRAY }}>
        <Row className="g-0 align-items-center my-2">
          <Col xs={4} className="text-start" style={{ paddingLeft: "4px" }}>
            <p className="cardDescription" style={{ marginBottom: "0px" }}>{superserie.name}</p>
          </Col>
          <Col xs={3} className="text-start" style={{ paddingLeft: "4px" }}>
            <p className="cardDescription" style={{ marginBottom: "0px" }}>Sets: {superserie.repetitions}</p>
          </Col>
          <Col xs={3} className="text-start" style={{ paddingLeft: "4px" }}>
            <p className="cardDescription" style={{ marginBottom: "0px" }}>Rest: {superserie.rest}''</p>
          </Col>
          <Col xs={1} className="align-self-center text-center">
            <FaEdit size={20} color={PALETTE.DARKGRAY} style={{ cursor: "pointer" }} onClick={() => { editCallback(superserie.id) }} />
          </Col>
          <Col xs={1} className="align-self-center text-center">
            <IoClose size={20} color={PALETTE.DARKGRAY} style={{ cursor: "pointer" }} onClick={onDeleteButtonClicked} />
          </Col>
        </Row>
        {workoutExercises.map((workoutExercise) => (
          <div key={workoutExercise.id}>
            <CardAdminWorkoutExercise
              workoutExercise={workoutExercise}
              editCallback={onEditButtonClicked}
              onDeleteButtonClicked={() => { onDeleteExerciseButtonClicked(workoutExercise.id) }}
              height={75}
            />
          </div>
        ))}
        <Button
          className="py-2"
          style={{ border: "0 solid", backgroundColor: PALETTE.KINDALIGHTGRAY, color: PALETTE.DARK }}
          onClick={onAddWorkoutExerciseButtonClicked}
        >Add exercise</Button>
      </Card>
    </>
  )
}